import script from "./BookingPayments.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingPayments.vue?vue&type=script&lang=ts&setup=true"

export default script